import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import { store } from "./redux/store";
import App from "./App";
import "./index.css";
import "./styles/buttons.css";
import "@phosphor-icons/web/regular/style.css";
import "@phosphor-icons/web/fill/style.css";
import "@phosphor-icons/web/duotone/style.css";
import "./assets/icons/linearicons.css";
import { installFetchInFlightDedupe } from "./services/fetchInFlightDedupe";
import axios from "axios";
import { installAxiosInFlightDedupe } from "./services/axiosInFlightDedupe";
// import "./linearicons.css";

installFetchInFlightDedupe();
installAxiosInFlightDedupe(axios);

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
);
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </React.StrictMode>,
);
